import React, { useState } from "react";
import { useDictionary } from "@adamlip/okeoke.client";
import SubmittedOrderItemList from "components/SubmittedOrder/SubmittedOrderItemList";
import Accordion from "components/Accordion";
import AccordionHead from "components/Accordion/AccordionHead";
import AccordionBody from "components/Accordion/AccordionBody";
import LoadSvg from "utils/LoadSvg-v3";

function SubmittedOrderItemAccordion(props) {
  const { className, order } = props;

  const { getValue } = useDictionary();
  const [accordionOpen, setAccordionOpen] = useState(false);

  return (
    <Accordion
      className={`${className != null ? className : ""}`}
      isOpen={accordionOpen}
      setIsOpen={setAccordionOpen}
      iconType={"type2"}
    >
      <AccordionHead>
        <div className="accordion-header-icon items-header-icon">
          {<LoadSvg name="setCart" />}
        </div>
        <div className="accordion-header-label items-header-label">
          {getValue("app_v2_basketLabel")}
        </div>
      </AccordionHead>
      <AccordionBody>
        <SubmittedOrderItemList
          order={order}
          details={true}
          className="order-details-itemList"
        />
      </AccordionBody>
    </Accordion>
  );
}

export default SubmittedOrderItemAccordion;
